export default "/img/CX.0bd6b149ea841934de3297c61adf5f71.png";